export const TRY_SIGN_IN = "TRY_SIGN_IN";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";

export const FETCHING_SCREEN = "FETCHING_SCREEN";
export const FETCHING_SCREEN_SUCCESS = "FETCHING_SCREEN_SUCCESS";
export const FETCHING_SCREEN_ERROR = "FETCHING_SCREEN_ERROR";

export const FETCHING_LOV = "FETCHING_LOV";
export const FETCHING_LOV_ERROR = "FETCHING_LOV_ERROR";
export const FETCHING_LOV_SUCCESS = "FETCHING_LOV_SUCCESS";

export const FETCHING_LOV_AUTO = "FETCHING_LOV_AUTO";
export const FETCHING_LOV_AUTO_SUCCESS = "FETCHING_LOV_AUTO_SUCCESS";
export const FETCHING_LOV_AUTO_ERROR = "FETCHING_LOV_AUTO_ERROR";

export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const ADD_QUERY = "ADD_QUERY";
export const REMOVE_QUERY = "REMOVE_QUERY";

export const SCOPE_CHANGED = "SCOPE_CHANGED";

export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";
export const HIDE_TOAST = "HIDE_TOAST";

export const FETCHING_DATA_IN_PROGRESS = "FETCHING_DATA_IN_PROGRESS";
export const FETCHING_DATA_DONE = "FETCHING_DATA_DONE";